<template>
    <div class="breadcrumbs-provider" aria-hidden="true"></div>
</template>

<script>
export default {

    name: 'Breadcrumbs',
    props: {
        items: Array,
    },
    methods: {
        applyDocumentTitle() {
            const title = (this.items || [])
                .map((item, i) => (i === 0 ? 'Data Heroes' : item?.text?.toUpperCase()))
                .join(' — ')
            document.title = title || 'Data Heroes'
        },
        publishItems() {
            this.$store.commit('setHeaderBreadcrumbs', {
                items: this.items || [],
                sourceKey: this.providerSourceKey,
            })
            this.applyDocumentTitle()
        },
    },
    watch: {
        items: {
            deep: true,
            handler() {
                this.publishItems()
            },
        },
    },
    created() {
        this.providerSourceKey = `${this.$route.fullPath}::${this._uid}`
    },
    mounted() {
        this.publishItems()
    },
    beforeDestroy() {
        if (this.$store.state.headerBreadcrumbsSourceKey === this.providerSourceKey) {
            document.title = 'Data Heroes'
        }
        this.$store.commit('clearHeaderBreadcrumbs', this.providerSourceKey)
    },
    data: () => ({ providerSourceKey: null }),
}
</script>

<style lang="sass" scoped>
.breadcrumbs-provider
    display: none
</style>
